
import AV from "leancloud-storage";
import { mapGetters, mapActions } from "vuex";
import ChinaAddressData from 'vux/src/datas/china_address.json'

import value2name from 'vux/src/filters/value2name'

export default {
props: ["value"],

async created() {
if (this.user) {
this.username = this.user.username || null
this.gender = this.user.gender || null
this.mobilePhoneNumber = this.user.mobilePhoneNumber || null
this.email = this.user.email || null
this.address.push(this.user.province || null)
this.address.push(this.user.city || null)
this.address.push(this.user.region || null)
}
},

data() {
return {
username: null,
gender: null,
mobilePhoneNumber: null,
code: null,
countDown: 60,
sendSmsTimer: null,
email: null,
address: [],
genderList: [{ key: 1, value: "男" }, { key: 2, value: "女" }],
addressData: ChinaAddressData,
didSendSMS: false
}
},

methods: {
...mapActions(["fetchUser"]),

async saveInfo() {

let username = (this.username || "").trim()
if (!username) {
this.$vux.toast.show({ text: '用户名不能为空', type: 'warn' })
return
}


if (this.gender != 1 && this.gender != 2) {
this.$vux.toast.show({ text: '请选择性别', type: 'warn' })
return
}


if (!this.address[0] || !this.address[1] || !this.address[2]) {
this.$vux.toast.show({ text: '请选择地区', type: 'warn' })
return
}
let addressRawValue = value2name(this.address, ChinaAddressData).split(' ')
let province = addressRawValue[0]
let city = addressRawValue[1]
let region = addressRawValue[2]


if (!this.mobilePhoneNumber) {
this.$vux.toast.show({ text: '请输入手机号码', type: 'warn' })
return
}
if (this.mobilePhoneNumber.toString().length != 11) {
this.$vux.toast.show({ text: '无效的手机号码', type: 'warn' })
return
}


if (this.user.mobilePhoneNumber != this.mobilePhoneNumber) {
if (!this.didSendSMS) {
this.$vux.toast.show({ text: '请发送验证码', type: 'warn' })
return
}

if (!this.code) {
this.$vux.toast.show({ text: '请输入验证码', type: 'warn' })
return
}
}

/* 存储 */


if (this.user.username != username) {

AV.Cloud.rpc('updateUsername', { username, ignoreUpdateUsernameRemainingTimes: true })
}


AV.User.current().set('gender', this.gender)
AV.User.current().set('province', province)
AV.User.current().set('city', city)
AV.User.current().set('region', region)
try {
await AV.User.current().save()
} catch (err) {
this.$vux.toast.show({ text: `发生错误：${err.message}`, type: 'warn' })
return
}


if (this.user.mobilePhoneNumber != this.mobilePhoneNumber) {
try {
await AV.Cloud.run("verifySMSCodeAndBindPhone", { mobilePhone: this.mobilePhoneNumber, code: this.code, client: "web" });
await AV.User.current().fetch()
} catch (err) {
this.$vux.toast.show({
text: err.code == 214 ? "该手机号已绑定" : `发生错误：${err.rawMessage || err.message}`,
type: "warn",
position: "middle",
});
return
}
}


let email = (this.email || "").trim()
if (email != "") {
AV.User.current().set('email', this.email)
try {
await AV.User.current().save()
} catch (err) {
}
}

await this.fetchUser()
this.$emit("input", false);
this.$emit("success");
},


async sendCodeSms() {
if (!this.canSendSms) {
return;
}

this.didSendSMS = false

try {
let that = this;
var captcha = new TencentCaptcha('198762067', async (res) => {
console.log(res)
console.log(that)
console.log(this)

let ticket = res.ticket
let randstr = res.randstr

try {
await AV.Cloud.run(
"sendSMSCodeViaTencentCloudCaptchaVerification",
{ ticket, randstr, mobilePhone: this.mobilePhoneNumber, client: "web", action: "bindPhone" }
)
} catch (err) {
console.log(err)
this.$vux.toast.text("图形码验证失败", "middle");
return
}

this.$vux.toast.text("短信验证码发送成功", "middle");

this.didSendSMS = true

this.$nextTick(() => {
this.$refs.code.focus()
})

this.setupSmsTimer()
})
captcha.show()
} catch (err) {
this.$vux.toast.text("图形验证码加载失败", "middle");
return
}
},

setupSmsTimer() {
this.countDown = 60;
this.sendSmsTimer = setInterval(() => {
this.countDown -= 1;
if (this.countDown <= 0 && this.sendSmsTimer) {
clearInterval(this.sendSmsTimer);
this.sendSmsTimer = null;
}
}, 1000);
}
},

computed: {
...mapGetters(["user"]),

shouldShowSmsCodeViews() {
return this.didSendSMS
},

canSendSms() {
return !this.sendSmsTimer && this.mobilePhoneNumber && this.mobilePhoneNumber.length == 11;
},

show: {
get() {
return this.value;
},
set(val) {
this.$emit("input", val);
},
},

sendSmsButtonTitle() {
return this.sendSmsTimer ? `${this.countDown} 秒` : "发送验证码";
},
},

watch: {
}
}



// WEBPACK FOOTER //
// ./src/components/common/FillInfoForQuizDialog.vue